import { KanaCell, KanaScript, KanaTable, hiraganaTable, katakanaTable } from '../alphabet/kana-data'

export type SelectedKana = {
    cell: KanaCell
    script: KanaScript
}

export function flattenKanaCells(table: KanaTable) {
    return [...table.baseRows.flat(), ...table.yoonRows.flat()].filter((cell) => cell.kana)
}

const hiraganaSequence = flattenKanaCells(hiraganaTable)
const katakanaSequence = flattenKanaCells(katakanaTable)
const kanaAudioIndexMap = new Map<string, number>()

hiraganaSequence.forEach((cell, index) => {
    kanaAudioIndexMap.set(cell.kana, index)
})
katakanaSequence.forEach((cell, index) => {
    kanaAudioIndexMap.set(cell.kana, index)
})

export function getKanaAudioPath(selected: SelectedKana) {
    const audioIndex = kanaAudioIndexMap.get(selected.cell.kana)
    if (typeof audioIndex !== 'number') {
        return null
    }
    return `/mp3/kana/${audioIndex}.m4a`
}

export function normalizeRomaji(romaji: string) {
    return romaji.replace(/\s*\(.+?\)/g, '').trim().toLowerCase()
}

export function getEndingVowel(romaji: string) {
    const matched = normalizeRomaji(romaji).match(/[aiueo](?!.*[aiueo])/)
    return matched?.[0] ?? null
}

export function normalizeKanaInput(input: string) {
    return input.trim().replace(/\s+/g, '')
}

export function isSameKana(a: SelectedKana | null, b: SelectedKana | null) {
    if (!a || !b) {
        return false
    }

    return a.script === b.script && a.cell.kana === b.cell.kana && a.cell.romaji === b.cell.romaji
}
